// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { EvidenceKind, Selection } from '../../../bygning/selection';
import { Button } from '../../Button';
import styles from './Inspector.module.css';

const EVIDENCE: readonly { kind: EvidenceKind; label: string; title: string }[] = [
  { kind: 'foto', label: 'Foto', title: 'De bedste billeder af delen' },
  { kind: 'pano', label: '360°', title: 'Nærmeste 360°-optagelse' },
  { kind: 'seg', label: 'Del op', title: 'Markér en ny del i et billede (SAM3)' },
];

export interface EvidenceButtonsProps {
  /** The part the evidence is for. */
  code: string;
  sel: Pick<Selection, 'ev' | 'partCode'>;
  setSel: (patch: Partial<Selection>) => void;
}

/**
 * Foto / 360° / Del op for one part: each only sets the selection
 * (`?part=&ev=`) — the evidence tile is the centre's — and a second press on
 * the open one closes it.
 */
export function EvidenceButtons({ code, sel, setSel }: EvidenceButtonsProps) {
  return (
    <div className={styles.evButtons} role="group" aria-label={`Evidens for ${code}`}>
      {EVIDENCE.map((e) => {
        const on = sel.ev === e.kind && sel.partCode === code;
        return (
          <Button
            key={e.kind}
            size="sm"
            aria-pressed={on}
            title={e.title}
            onClick={() => setSel(on ? { ev: null } : { partCode: code, ev: e.kind })}
          >
            {e.label}
          </Button>
        );
      })}
    </div>
  );
}
